import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModalComponent } from '@card-software/library';
import { MachineAssignmentImportResult } from '../../../../../models/commands/machine-assignment-import-command';
import { ProductionGroup } from '../../../../../models/production/production-group.model';
import { ProductionGroupProxyService } from '../../../../../proxies/production/production-group.proxy.service';

@Component({
  selector: 'app-machine-assignment-preview-modal',
  templateUrl: './machine-assignment-preview-modal.component.html',
  styleUrl: './machine-assignment-preview-modal.component.scss',
})
export class MachineAssignmentPreviewModalComponent extends BaseModalComponent<{ override: boolean }> implements OnInit {
  private readonly productionGroupProxyService = inject(ProductionGroupProxyService);
  private readonly translateService = inject(TranslateService);

  @Input() previewResult!: MachineAssignmentImportResult;

  overrideEnabled = signal(false);
  groups = signal<ProductionGroup[]>([]);

  hasDuplicates = computed(() => this.previewResult.totalDuplicates > 0);
  canSave = computed(() => !this.hasDuplicates() || this.overrideEnabled());

  ngOnInit(): void {
    this.productionGroupProxyService.getAll().subscribe({
      next: (response) => {
        if (response?.success && response.data) {
          this.groups.set(response.data);
        }
      },
      error: (error) => console.error('Error loading production groups:', error),
    });
  }

  getGroupName(ref: string | null): string {
    if (!ref) return '-';
    const lang = (this.translateService.currentLang ?? 'en') as 'en' | 'es';
    const group = this.groups().find((g) => g.id === ref);
    if (!group) return ref;
    return group.name[lang] || group.name['en'] || ref;
  }

  getStatusSeverity(status: string): 'success' | 'warn' | 'danger' | 'secondary' {
    switch (status) {
      case 'Ok':
        return 'success';
      case 'Duplicate':
        return 'warn';
      case 'MissingData':
        return 'danger';
      default:
        return 'secondary';
    }
  }

  formatDate(date: { year: number; month: number; day: number }): string {
    return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
  }

  onConfirm(): void {
    this.close({ action: 'save', data: { override: this.overrideEnabled() } });
  }

  onCancel(): void {
    this.close({ action: 'close', data: { override: false } });
  }
}
